module.exports = __webpack_public_path__ + "img/pr-1.763aa6a5.png";